import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

export const fetchalldetailsById = createAsyncThunk(
    'performance/fetchalldetails',
    async ( Id: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/performance/selfappraisaldeatils/${Id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Achievement');
        }
    }
);

export const createachievemnet = createAsyncThunk(
    'performance/createdetails',
    async ( data: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post(`/performance/achievement`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Achievement');
        }
    }
);